<template>
  <v-container class="cmp-royalty-accounts-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedAccountDetails &&
              selectedAccountDetails.account &&
              selectedAccountDetails.account.royalty_account_name
            "
          >
            <span
              v-if="selectedAccountDetails && selectedAccountDetails.account"
              >{{
                selectedAccountDetails.account.royalty_account_name ||
                "Account Name"
              }}</span
            >
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <!-- <div
                v-if="selectedAccountDetails && selectedAccountDetails.account"
              >
                {{
                  selectedAccountDetails.account.royalty_account_name ||
                  "Account Name"
                }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="accountSidewindowTabs"
        :options="[
          {
            text: $t('update_b2b_data'),
            value: 'update_b2b_data',
          },
          {
            text: `${$t('export')} ${$t('balance')}`,
            value: 'exports',
          }
          ,
          {
            text: $t('documents_string'),
            value: 'documents',
          },
        ]"
        @optionClicked="onTabOptionClicked"
      >
        <!-- :loading="selectedAccountDetails && selectedAccountDetails.loading" -->
        <gtab>
          <grow>
            <gcol>
              <gbox
                :title="$t('royalty_account_setup')"
                h="258"
                :loading="
                  selectedAccountDetails.get_royalty_account_setup_loading
                "
              >
                <AccountSetup
                  v-if="!selectedAccountDetails.get_royalty_account_setup_loading"
                  :selectedAccountDetails="selectedAccountDetails"
                  @changed="onAccountChanged"
                  @selected="onSelectedAccount"
                />
              </gbox>
              <gbox
                :loading="
                  selectedAccountDetails.get_royalty_account_setup_loading
                "
                :title="$t('accounting_setup')"
              >
                <AccountingSetup
                  @changed="onAccountChanged"
                  :selectedAccountDetails="selectedAccountDetails"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedAccountDetails &&
                      selectedAccountDetails.contacts &&
                      selectedAccountDetails.contacts.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :loading="
                  selectedAccountDetails.get_royalty_account_setup_loading
                "
                :title="$t('related_contacts')"
              >
                <RelatedContacts
                  :contact_relations="selectedAccountDetails.contacts"
                  :external_id="`${selectedAccountDetails.account.royalty_account_id}`"
                  :external_table="'royalty_account'"
                  @delete="onRelatedContactDelete"
                  @changed="onRelatedContactChange"
                  @contact_selected="onRelatedContactSelected"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedAccountDetails &&
                      selectedAccountDetails.files &&
                      selectedAccountDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :loading="
                  selectedAccountDetails.get_royalty_account_setup_loading
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedAccountDetails.files"
                  :externalId="`${this.selectedAccountDetails.account.royalty_account_id}`"
                  :externalTable="'royalty_account'"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="$t('main_contact')"
                :loading="
                  selectedAccountDetails.get_royalty_account_setup_loading
                "
              >
                <InvoiceContact
                  id="invoiceContact"
                  :invoiceContact="selectedAccountDetails.contact || {}"
                  :contactConfig="{
                    external_id:
                      selectedAccountDetails.account.royalty_account_id,
                    external_table: 'l_royalty_accounts',
                    external_name: 'contact_id',
                    config_type: 'RoyaltyAccountsInvoiceConfig',
                    key: 'royalty_account_id',
                  }"
                />
              </gbox>
              <gbox
                :title="$t('export_options')"
                :loading="
                  selectedAccountDetails.get_royalty_account_setup_loading
                "
              >
                <ExportOptions
                  @changed="onAccountChanged"
                  :selectedAccountDetails="selectedAccountDetails"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedAccountDetails &&
                      selectedAccountDetails.related_ext_users &&
                      selectedAccountDetails.related_ext_users.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :loading="
                  selectedAccountDetails.get_royalty_account_setup_loading
                "
                :title="$t('b2b_access')"
              >
                <B2BAccess
                  @add_click="onAddClick"
                  :selectedAccountDetails="selectedAccountDetails"
                  @changed="onExternalUserChanged"
                />
              </gbox>
              <gbox
                :title="$t('notes')"
                bc="var(--bc-note)"
                :loading="
                  selectedAccountDetails.get_royalty_account_setup_loading
                "
              >
                <DBoxTextarea
                  :value="selectedAccountDetails.royalty_account.notes"
                  :id="'notes'"
                  @blur="onNotesBlur"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="tab_title_contracts">
          <!-- <template #header>
            <grow>
              <gcol>
                <div class="ut-flex">
                  <button
                    @click="onAddClick('contract_document_template')"
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                  >
                    {{ $t("document") }}
                  </button>
                </div>
              </gcol>
            </grow>
          </template> -->
          <grow>
            <gcol>
              <gbox
                :loading="
                  selectedAccountDetails.get_royalty_account_contracts_loading
                "
                :h="
                  boxHeight(
                    selectedAccountDetails &&
                      selectedAccountDetails.contracts &&
                      selectedAccountDetails.contracts.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('contracts')"
              >
                <ContractList
                  @changed="
                    (e) =>
                      onRoyaltyAccountItemChanged({
                        ...e,
                        path: 'contracts',
                        primaryKey: 'contract_id',
                      })
                  "
                  @add_click="onAddClick"
                  @selected="onSelectedContract"
                  :selectedAccountDetails="selectedAccountDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="tab_title_statements">
          <grow>
            <gcol>
              <gbox
                :loading="
                  selectedAccountDetails.get_royalty_account_statements_loading
                "
                :h="
                  boxHeight(
                    selectedAccountDetails &&
                      selectedAccountDetails.statement_data &&
                      selectedAccountDetails.statement_data.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('tab_title_statements')"
              >
                <AccountStatementList
                  @selectedStatement="onSelectedStatement"
                  @add_click="onAddClick"
                  @edit_click="onEditRpClick"
                  @delete_statement="onStatementDeleted"
                  @changed="e => onRoyaltyAccountItemChanged({
                    ...e,
                    path: 'statement_data',
                    primaryKey: 'royalty_period_id',
                  })"
                  :selectedAccountDetails="selectedAccountDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="tab_title_balances">
          <!-- <template #header>
            <grow>
              <gcol>
                <div class="ut-flex">
                  <button
                    @click="onExportMenuClick()"
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                  >
                    {{ $t("export") }}
                  </button>
                </div>
              </gcol>
            </grow>
          </template> -->
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: dBoxBalancesRowCount,
                    offset:
                      selectedAccountDetails &&
                      selectedAccountDetails.balances &&
                      selectedAccountDetails.balances.length > 0
                        ? balancesSearchFlag
                          ? NTOffsets.WithHeaderDBoxBottom + 52
                          : NTOffsets.WithHeaderDBoxBottom
                        : balancesSearchFlag
                        ? NTOffsets.WithHeaderDBoxBottom + 52
                        : NTOffsets.WithHeaderDBoxBottom,
                  })
                "
                :loading="
                  selectedAccountDetails.royalty_account_balances_loading
                "
                :title="$t('balances')"
              >
                <BalanceList
                  @add_click="onAddClick"
                  @changed="e => onRoyaltyAccountItemChanged({
                    ...e,
                    path: 'balances',
                    primaryKey: 'balance_id',
                  })"
                  @showSearchFlag="onBalancesSearchClick"
                  :selectedAccountDetails="selectedAccountDetails"
                  :advanceSearchData="advanceSearchData"
                  @search="onAdvanceSearchData"
                  @scroll="onScroll"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <!-- Believe Special Payments List Removed from here -->
        <!-- <gtab v-if="believe_special" id="tab_title_payments">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedAccountDetails &&
                      selectedAccountDetails.payments &&
                      selectedAccountDetails.payments.length,
                    offset:
                      selectedAccountDetails &&
                      selectedAccountDetails.payments &&
                      selectedAccountDetails.payments.length > 0
                        ? NTOffsets.WithHeaderDBoxBottom + 52
                        : NTOffsets.WithHeaderDBoxBottom,
                    min: 0,
                  })
                "
                :title="$t('payments')"
              >
                <PaymentList
                  @edit_click="onEditClick"
                  :selectedAccountDetails="selectedAccountDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab> -->
      </glayout>
    </div>

    <ModalContainer :modalKey="'balanceAdvanceSearch'" :width="'small'">
      <BalanceAdvanceSearchForm
        @added="onAdvanceSearchBalance"
        @search="onAdvanceSearchData"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addContractForm'" :width="'600'">
      <AddContractForm
        :selectedAccountDetails="selectedAccountDetails"
        @add_click="onAddClick"
        @added="onContractAdded"
        @cancelled="onDialogCancelled"
        @selected="onSelectedContract"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addStatementForm'" :width="'small'">
      <AddStatementForm
        :selectedAccountDetails="selectedAccountDetails"
        @cancelled="onDialogCancelled"
        @added="onStatementAdded"
      />
    </ModalContainer>
    <!-- <ModalContainer :modalKey="'editPaymentForm'" :width="'medium'">
      <EditPaymentForm
        :selectedPayment="selectedPayment"
        :selectedAccountDetails="selectedAccountDetails"
        @cancelled="onDialogCancelled"
        @added="onEditPaymentAdded"
      />
    </ModalContainer> -->
    <ModalContainer :modalKey="'addMainContactForm'" :width="'medium'">
      <AddMainContactForm
        :selectedAccountDetails="selectedAccountDetails"
        @cancelled="onDialogCancelled"
        @added="onContactAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'copyContractForm'" :width="'small'">
      <CopyContractForm
        :selectedAccountDetails="selectedAccountDetails"
        @cancelled="onDialogCancelled"
        @added="onContractAdded"
        @selected="onSelectedContract"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'harryFoxContractForm'" :width="'500'">
      <HarryFoxContractForm
        :selectedAccountDetails="selectedAccountDetails"
        @cancelled="onDialogCancelled"
        @added="onContractAdded"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'contractDocumentTemplate'" :width="'small'">
      <ContractDocumentTemplate
        :selectedAccountDetails="selectedAccountDetails"
        @cancelled="onDialogCancelled"
        @added="onContractAdded"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'addAccessForm'" :width="'medium'">
      <AddAccessForm
        :selectedAccountDetails="selectedAccountDetails"
        @added="onExternalUserAdded"
        @cancelled="onDialogCancelled"
        @add_click="onAddClick"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'newAccessForm'" :width="'500'">
      <NewAccessForm
        :selectedAccountDetails="selectedAccountDetails"
        @added="onExternalUserAdded"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editRoyaltyStatement'" :width="'small'">
      <EditRoyaltyStatement
        :selectedRpPayment="selectedRpPayment"
        @cancelled="onDialogCancelled"
        @edited="onEditRPModalData"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'deleteStatementModal'" :width="'small'">
      <DeleteStatementModal
        :selectedAccountDetails="selectedAccountDetails"
        :selectedStatement="selectedStatement"
        :invoiceInfo="invoiceInfo"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'externalUserListModal'" :width="'small'">
      <ExternalUserListModal
        :selectedAccountDetails="selectedAccountDetails"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { createTV } from "../../../../models/text-value.model";
import { accountsRoyaltyGetters } from "../../store/accounts/getters";
import {
  royaltyAccountsListLDTRoutes,
  royaltyContractsListLDTRoutes,
} from "../../router/routes";
import { contactListLDTRoutes } from "../../../contacts/router/routes";
import {
  checkTabGridItemPermission,
  checkTabListPermission,
} from "../../../../router/guard";

import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import BoxWidget from "@plugins/box-widget/box-widget";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import AccountSetup from "./account-setup";
import MainContact from "./main-contact.vue";
import ExportOptions from "./export-options.vue";
import AccountingSetup from "./accounting-setup.vue";
import ContractList from "./contract-list.vue";
import AccountStatementList from "./account-statement-list.vue";
import BalanceList from "./balance-list.vue";
// import PaymentList from "./payment-list.txt";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import RelatedContacts from "@/dt-plugins/add-contact-relation/related-contacts.vue";
import ModalContainer from "@dtplugins/modal/modal-container";
import AddContractForm from "./add-contract-form.vue";
import AddStatementForm from "./add-statement-form.vue";
import EditPaymentForm from "./edit-payment-form.vue";
import EditRoyaltyStatement from "./edit-royalty-statement.vue";
import AddMainContactForm from "./add-main-contact-form.vue";
import BalanceAdvanceSearchForm from "./balances-advance-search-form.vue";
import CopyContractForm from "./copy-contract-form.vue";
import HarryFoxContractForm from "./harry-fox-contract-form.vue";
import ContractDocumentTemplate from "./contract-document-template.vue";
import AddAccessForm from "./add-b2b-access-form.vue";
import NewAccessForm from "./new-b2b-access-form.vue";
import ExternalUserListModal from "./external-user-list-modal.vue";
import B2BAccess from "./b2b-access.vue";
import DeleteStatementModal from "./delete-statement-modal.vue";
import {
  createModalMixin,
  openModalRoute,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import InvoiceContact from "@/dt-plugins/dbox-invoice-contact/dbox-invoice-contact.vue";
import { AccountsService } from "../../services/accounts.service";
export const moduleRoute = "royalty";
export const submenuRoute = "accounts";
import { groupBy } from "lodash";
import { AccountService } from "../../../distribution/services/account.service";
import { numberSorterFunction } from "../../../../utility/sorting";
import {
  executeFunctionExpInt,
  executeFunctionExpIntP,
  wait,
} from "../../../../utility";

export default {
  components: {
    // PaymentList,

    BoxWidget,
    ModalContainer,
    RelatedContacts,
    AccountSetup,
    DBoxTextarea,
    MainContact,
    DBoxFiles,
    ExportOptions,
    AccountingSetup,
    ContractList,
    BalanceList,
    AccountStatementList,
    InvoiceContact,
    AddContractForm,
    AddStatementForm,
    EditPaymentForm,
    BalanceAdvanceSearchForm,
    AddMainContactForm,
    CopyContractForm,
    HarryFoxContractForm,
    ContractDocumentTemplate,
    B2BAccess,
    AddAccessForm,
    NewAccessForm,
    DeleteStatementModal,
    ExternalUserListModal,
    EditRoyaltyStatement,
  },
  data() {
    return {
      selectedStatement: {},
      selectedRpPayment: {},
      selectedPayment: {},
      advanceSearchData: {},
      invoiceInfo: {},
      balancesSearchFlag: false,
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("balanceAdvanceSearch"),
    createModalMixin("addContractForm"),
    createModalMixin("addStatementForm"),
    createModalMixin("editPaymentForm"),
    createModalMixin("addMainContactForm"),
    createModalMixin("copyContractForm"),
    createModalMixin("harryFoxContractForm"),
    createModalMixin("contractDocumentTemplate"),
    createModalMixin("addAccessForm"),
    createModalMixin("newAccessForm"),
    createModalMixin("deleteStatementModal"),
    createModalMixin("editRoyaltyStatement"),
    createModalMixin("externalUserListModal"),
  ],
  computed: {
    ...mapGetterObject(storeNS, accountsRoyaltyGetters),
    believe_special() {
      return this.$store.getters.account.believe_special;
    },
    accountSidewindowTabs: function () {
      return checkTabListPermission(
        moduleRoute,
        submenuRoute,
        this.believe_special
          ? [
              {
                route: "overview",
                value: this.$t("setup"),
              },
              {
                route: "tab_title_contracts",
                value: this.$t("tab_title_contracts"),
              },
              {
                route: "tab_title_statements",
                value: this.$t("tab_title_statements"),
              },
              {
                route: "tab_title_balances",
                value: this.$t("tab_title_balances"),
              },
              {
                route: "tab_title_payments",
                value: this.$t("tab_title_payments"),
              },
            ]
          : [
              {
                route: "overview",
                value: this.$t("setup"),
              },
              {
                route: "tab_title_contracts",
                value: this.$t("tab_title_contracts"),
              },
              {
                route: "tab_title_statements",
                value: this.$t("tab_title_statements"),
              },
              {
                route: "tab_title_balances",
                value: this.$t("tab_title_balances"),
              },
              // {
              //   route: "contracts",
              //   value: this.$t("contracts"),
              // },
              // {
              //   route: "statements",
              //   value: this.$t("statements"),
              // },
              // {
              //   route: "balances",
              //   value: this.$t("balances"),
              // },
            ]
      );
    },
    // TABULATION REFACTORING

    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
    balanceLength: function () {
      // console.log("ss", this.selectedAccountDetails.balances.length);
      return (
        this.selectedAccountDetails &&
        this.selectedAccountDetails.balances &&
        this.selectedAccountDetails.balances.length
      );
    },
    selectedAccountDetails: function () {
      const selectedAccount =
        this.accountsDetails?.[this.royalty_account_id] || {};
      //  console.log("selected Account", selectedAccount);
      let account = selectedAccount?.account || {};
      let royalty_account = selectedAccount?.ra || {};
      royalty_account = {
        ...royalty_account,
        json_data: selectedAccount?.ra?.json_data?.aliases,
        royalty_account_id: `DT-00000${selectedAccount?.ra?.royalty_account_id}`,
        believe_access_email:
          selectedAccount?.ra?.json_data?.believe_access_email,
        cost_url_flag: selectedAccount?.ra?.cost_url_flag == 1 ? true : false,
        export_options_promos:
          selectedAccount?.ra?.export_options_promos == 1 ? true : false,
      };
      account = {
        ...selectedAccount?.ra,
      };
      //  console.log("accountaccount", account);
      const files = selectedAccount?.files || [];
      const contract = selectedAccount?.contract || {};

      const labelStatusesTV = selectedAccount?.label_statuses
        ? selectedAccount?.label_statuses.map((e) => {
            return {
              text: e["label_status_name"],
              value: e["label_status_id"],
              color: `#${e["label_status_colour"]}`,
            };
          })
        : [];

      // createTV(
      //   selectedAccount?.label_statuses || [],
      //   "label_status_name",
      //   "label_status_id"
      // );
      const languagesTV = selectedAccount?.languages
        ? selectedAccount?.languages.map((e) => {
            return {
              text: e[1],
              value: e[0],
            };
          })
        : [];
      const royalty_periodsTV = createTV(
        selectedAccount?.royalty_periods || [],
        "label",
        "value"
      );

      const account_baseTV = createTV(
        selectedAccount?.account_base || [],
        "label",
        "value"
      );

      const invoice_project = selectedAccount?.invoice_project || {};
      const vat_typesTV = [
        { text: `${invoice_project.vat_rate1} %`, value: 1 },
        { text: `${invoice_project.vat_rate2} %`, value: 2 },
      ];

      // createTV(
      //   selectedAccount?.vat_types || [],
      //   "vat_type_name",
      //   "vat_type_id"
      // );
      const invoice_projectsTV = createTV(
        selectedAccount?.invoice_projects || [],
        "invoice_project_name",
        "invoice_project_id"
      );
      const companiesTV = createTV(
        selectedAccount?.companies || [],
        "company_name",
        "company_id"
      );
      const tax_groupsTV = createTV(
        selectedAccount?.tax_groups || [],
        "tax_group_name",
        "tax_group_id"
      );
      const physical_export_optionsTV = createTV(
        selectedAccount?.physical_export_options || [],
        "label",
        "value"
      );
      const digital_export_optionsTV = createTV(
        selectedAccount?.digital_export_options || [],
        "label",
        "value"
      );
      const currency_separator_optionsTV = createTV(
        selectedAccount?.currency_separator_options || [],
        "textKey",
        "value"
      );
      const arrBalances = selectedAccount.balances || [];
      const obj = groupBy(arrBalances, "period");
      let balances = [];
      if (Object.keys(obj).length > 0) {
        Object.keys(obj).forEach((value, index) => {
          let objectValues = Object.values(obj)[index];
          objectValues[0].new_group_title = 1;
          objectValues[0].group_title = this.$t(value);
          objectValues = objectValues.map((obj) => {
            obj.disabled = value === "open_balances" ? false : true;
            return obj;
          });
          balances = [...balances, ...objectValues];
        });
      }
      // console.log("balances111", {
      //   ...selectedAccount,
      //   account,
      //   royalty_account,
      //   files,
      //   contract,
      //   labelStatusesTV,
      //   royalty_periodsTV,
      //   account_baseTV,
      //   vat_typesTV,
      //   invoice_projectsTV,
      //   companiesTV,
      //   tax_groupsTV,
      //   physical_export_optionsTV,
      //   digital_export_optionsTV,
      //   currency_separator_optionsTV,
      //   balances,
      //   languagesTV
      // });
      return {
        ...selectedAccount,
        account,
        royalty_account,
        files,
        contract,
        labelStatusesTV,
        royalty_periodsTV,
        account_baseTV,
        vat_typesTV,
        invoice_projectsTV,
        companiesTV,
        tax_groupsTV,
        physical_export_optionsTV,
        digital_export_optionsTV,
        currency_separator_optionsTV,
        balances,
        languagesTV,
        invoice_project,
      };
    },
    dBoxBalancesRowCount: function () {
      const totalCount = this.selectedAccountDetails.balances.reduce(
        (acc, curr) => {
          if (curr.new_group_title == 1 || curr.new_group_title == "1") {
            acc += 2;
          } else {
            acc += 1;
          }
          return acc;
        },
        0
      );
      return this.selectedAccountDetails?.balances?.length > 0 ? totalCount : 0;
    },

    //MARK: Computed
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    onB2BClick: async function () {
      const res = await AccountsService.updateB2BData(
        this.selectedAccountDetails?.account?.royalty_account_id
      );
      const res1 = await AccountsService.get_royalty_account_statements(
        this.selectedAccountDetails?.account?.royalty_account_id
      );
      this[ActionTypes.RoyaltyAccountsStatements.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        statement_data: res1.data.royalty_periods || [],
      });
    },
    onTabOptionClicked(value) {
      switch(value) {
        case 'documents':
          openModalRoute2(this, "dtTemplateList", {
              external_id: this.royalty_account_id,
          });
          break;
        case 'exports':
          this.onExportMenuClick()
          break;
        case 'update_b2b_data':
          this.onB2BClick();

          break;
       
          
      }

    },
    onRelatedContactSelected: function () {
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: contact.contact_id,
          tab: "overview",
        },
      });
    },
    onSelectedStatement(item) {
      this.selectedStatement = { ...item.selectedStatement };
      this.invoiceInfo = { ...item.invoiceInfo };
    },
    onRelatedContactDelete: function (contact) {
      this[ActionTypes.AccountsRelatedContacts.DELETE.SINGLE]({
        contact,
        selectedAccountDetails: this.selectedAccountDetails,
      });
    },
    onRelatedContactChange: function ({ name, value, item }) {
      this[ActionTypes.AccountsRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedAccountDetails: this.selectedAccountDetails,
      });
    },
    onRoyaltyAccountItemChanged: function (payload) {
      this[ActionTypes.AccountsDetails.UPDATE.SINGLE]({
        ...payload,
        selectedAccountDetails: this.selectedAccountDetails,
      });
    },
    onAdvanceSearchData: function (e) {
      this.advanceSearchData = {
        ...e,
      };
    },
    onAdvanceSearchBalance: function (e) {
      this[ActionTypes.RoyaltyAccountsBalances.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        balances: e || [],
      });
      this.onDialogCancelled();
    },
    onCopyContractAdded: function (e) {},
    onAccountChanged: function (payload) {
      // console.log("Changed value ", payload);
      this[ActionTypes.AccountsDetails.UPDATE.SINGLE]({
        ...payload,
        selectedAccountDetails: this.selectedAccountDetails,
      });
    },

    onSelectedAccount: function (selectedRoyaltyAccountId) {
      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: selectedRoyaltyAccountId,
          tab: "overview",
        },
      });
    },
    onNotesBlur: function (event) {
      this.onAccountChanged({
        name: "notes",
        value: event.target.value,
      });
    },

    onStatementDeleted(royalty_period) {
      this[ActionTypes.RoyaltyAccountsStatements.DELETE.SINGLE]({
        royalty_account_id: this.selectedAccountDetails?.account?.royalty_account_id,
        ...royalty_period
      });
    },
    // MARK: Methods

    onAdded: function (payload) {
      this.onDialogCancelled();
    },
    onExportMenuClick: async function () {
      const fileURL = await AccountsService.exportRoyaltyBalaces(
        this.selectedAccountDetails?.account?.royalty_account_id
      );
      console.log({ fileURL: fileURL });
      location.href = fileURL;
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddClick: function (e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onEditRpClick: function (e) {
      this.selectedRpPayment = {
        ...e,
      };

      openModalRoute(this, "edit_royalty_statement", {
        mode: "add",
        royalty_period_id: e.royalty_period_id,
      });
    },
    onContactAdded: function (e) {
      this[ActionTypes.RoyaltyAccountsMainContacts.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        contact: e || {},
      });
      this.onDialogCancelled();
    },

    onContractAdded: async function (e) {
      const res = await AccountsService.get_royalty_account_contracts(
        this.selectedAccountDetails?.account?.royalty_account_id
      );
      this[ActionTypes.RoyaltyAccountsContracts.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        contracts: res.data.contracts || [],
      });
      this.onDialogCancelled();
    },
    onExternalUserChanged: function (e) {
      const res = AccountsService.modify({
        ...e,
      });
      const related_ext_users =
        this.selectedAccountDetails.related_ext_users.map((p) => {
          if (p.external_user_id === e.external_user_id) {
            p = {
              ...p,
              language: e.value,
            };
          }
          return p;
        });
      this[ActionTypes.RoyaltyExternalUser.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        related_ext_users: related_ext_users || [],
      });
      this.onDialogCancelled();
    },
    onExternalUserAdded: function (e) {
      this[ActionTypes.RoyaltyExternalUser.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        related_ext_users: e || [],
      });
      this.onDialogCancelled();
    },

    onStatementAdded: function (e) {
      console.log({ "accounts-sidewindow.vue:836 e": e });
      // Short-Term Periodical Partial Update of the statement
      let statementData = this.selectedAccountDetails?.statement_data;
      // console.log({'accounts-sidewindow.vue:840 statementData' : statementData});

      // this[ActionTypes.RoyaltyAccountsStatements.FETCH.ALL]({
      //   royalty_account_id:
      //     this.selectedAccountDetails?.account?.royalty_account_id,
      // });
      // executeFunctionExpInt(
      //   () => {
      //     console.log({
      //       ExecuteFunctionExpInt: 1,
      //       statement_Data: this.selectedAccountDetails?.statement_data,
      //     });
      //     this[ActionTypes.RoyaltyAccountsStatements.FETCH.ALL]({
      //       royalty_account_id:
      //         this.selectedAccountDetails?.account?.royalty_account_id,
      //     });
      //   },
      //   (count, _) => {
      //     // console.log({'accounts-sidewindow.vue:851 count' : count});
      //     // console.log({'accounts-sidewindow.vue:852 this.selectedAccountDetails?.statement_data?.length' : this.selectedAccountDetails?.statement_data?.length});
      //     // console.log({'accounts-sidewindow.vue:852 statementData?.length' : statementData?.length});
      //     //       (e) => e?.royalty_period_amount
      //     //     )});
      //     console.log({
      //       count,
      //       statement_Data: this.selectedAccountDetails?.statement_data,
      //     });

      //     // return count > 6 || statementData?.length != this.selectedAccountDetails?.statement_data?.length;
      //     return (
      //       (count > 2 &&
      //         this.selectedAccountDetails?.statement_data?.every(
      //           (e) => e?.royalty_period_amount
      //         )) ||
      //       count > 12
      //     );
      //   }
      // );

      this.refreshRoyaltyPeriods();
    },
    refreshRoyaltyPeriods() {
      executeFunctionExpIntP(
        () => {
          this[ActionTypes.RoyaltyAccountsStatements.FETCH.ALL]({
            royalty_account_id:
              this.selectedAccountDetails?.account?.royalty_account_id,
          });
        },
        (count) => {
          return (
            (count > 3 &&
              this.selectedAccountDetails?.statement_data?.every(
                (e) => e?.royalty_period_amount
              )) ||
            count > 12
          );
        },
        1,
        1000
      );
    },
    onEditRPModalData: function (e) {
      // const statement_data = this.selectedAccountDetails.statement_data.map(
      //   (p) => {
      //     if (p.royalty_period_id === e.royalty_period_id) {
      //       p = {
      //         ...e,
      //         json_data: e.json_data,
      //       };
      //     }
      //     return p;
      //   }
      // );

      // this[ActionTypes.RoyaltyAccountsStatements.SET.ALL]({
      //   royalty_account_id:
      //     this.selectedAccountDetails?.account?.royalty_account_id,
      //   statement_data: statement_data || [],
      // });

      this.refreshRoyaltyPeriods();
      this.onDialogCancelled();
    },
    // onEditPaymentAdded: async function (e) {
    //   // const payments = this.selectedAccountDetails.payments.map((p) => {
    //   //   if (p.payment_id === e.payment_id) {
    //   //     p = {
    //   //       ...e,
    //   //     };
    //   //   }
    //   //   return p;
    //   // });

    //   // console.log({ payments });

    //   await wait(1000);

    //   this.refreshRoyaltyPeriods();

    //   // this[ActionTypes.RoyaltyAccountsPayments.SET.ALL]({
    //   //   royalty_account_id:
    //   //     this.selectedAccountDetails?.account?.royalty_account_id,
    //   //   payments: payments || [],
    //   // });
    //   this.onDialogCancelled();
    // },

    onSelectedContract: function (selectedContractId) {
      this.$router.push({
        name: royaltyContractsListLDTRoutes.names.tab,
        params: {
          contract_id: selectedContractId,
          tab: "overview",
        },
      });
    },
    onContactSelected: function (selectedContactId) {
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: selectedContactId,
          tab: "overview",
        },
      });
    },

    onBalancesSearchClick: function (payload) {
      this.balancesSearchFlag = payload;
    },

    onScroll: function (payload) {
      console.log(payload, "PPPPPPPPPPPP");
      this[ActionTypes.RoyaltyAccountsBalances.INSERT.MULTIPLE]({
        royalty_account_id: this.royalty_account_id,
        start: payload,
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-accounts-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 130px);
  }
}
</style>
